import { type RefObject, useEffect, useState } from "react";
import { getScrollContainer } from "web_myplann/Shared/Utils/getScrollContainer";

type Options = {
	root?: Element | null;
	topOffsetPx?: number;
};

export const useScrolledPastTop = (
	elementRef: RefObject<HTMLElement | null>,
	{ root, topOffsetPx = 0 }: Options = {},
): boolean => {
	const [scrolledPast, setScrolledPast] = useState(false);

	useEffect(() => {
		const element = elementRef.current;
		if (!element) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				const rootTop = entry.rootBounds?.top ?? 0;
				setScrolledPast(
					!entry.isIntersecting && entry.boundingClientRect.top < rootTop,
				);
			},
			{
				root: root === undefined ? getScrollContainer(element) : root,
				rootMargin: `-${topOffsetPx}px 0px 0px 0px`,
				threshold: 0,
			},
		);

		observer.observe(element);

		return () => observer.disconnect();
	}, [elementRef, root, topOffsetPx]);

	return scrolledPast;
};
